<template>
  <header class="public-topbar sticky top-0 z-[9999] border-b border-white/10 bg-neutral-950/85 shadow-[0_18px_60px_rgba(0,0,0,0.35)] backdrop-blur-xl">
    <div class="pointer-events-none absolute inset-x-0 bottom-[-1px] h-px bg-gradient-to-r from-transparent via-scio-yellow-p3/50 to-transparent"></div>

    <div class="mx-auto flex h-[70px] max-w-7xl items-center gap-4 px-4 sm:px-6">
      <button
        type="button"
        class="group inline-flex items-center gap-3 rounded-lg px-2 py-2 transition hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3/70"
        @click="navigateTo('splash')"
      >
        <img src="/icons/scio-logo-v2.svg" alt="Scio" class="h-9 sm:h-10" />
      </button>

      <nav class="ml-auto hidden items-center gap-2 lg:flex">
        <button
          v-for="item in navItems"
          :key="item.name"
          type="button"
          class="inline-flex items-center gap-2 px-4 py-2 scio-text-body scio-weight-semibold text-neutral-300 transition hover:bg-white/7 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3/70"
          :class="isRouteActive(item.path) ? 'bg-white/10 text-white' : ''"
          @click="navigateTo(item.name)"
        >
          {{ item.label }}
        </button>

        <div class="mx-2 h-6 w-px bg-white/10"></div>

        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 scio-text-body scio-weight-semibold text-slate-950 shadow-sm shadow-black/20 transition hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3/70 focus-visible:ring-offset-2 focus-visible:ring-offset-neutral-950"
          :style="{ backgroundColor: 'var(--color-scio-yellow-p2)' }"
          @click="navigateTo('login')"
        >
          Log in
        </button>
      </nav>

      <button
        type="button"
        class="ml-auto inline-flex items-center gap-3 px-4 py-2 scio-text-body scio-weight-semibold text-neutral-200 transition hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3/70 lg:hidden"
        :class="isMobileMenuOpen ? 'bg-white/10' : ''"
        @click="toggleMobileMenu"
      >
        <img src="/images/scio-hamburger.svg" alt="" class="h-4 w-4" />
        Menu
      </button>
    </div>

    <div v-if="isMobileMenuOpen" class="border-t border-white/10 bg-neutral-950/95 shadow-2xl backdrop-blur-xl lg:hidden">
      <div class="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3 sm:px-6">
        <button
          v-for="item in mobileItems"
          :key="item.name"
          type="button"
          class="flex items-center justify-between px-4 py-3 text-left scio-text-body scio-weight-semibold text-neutral-300 transition hover:bg-white/5 hover:text-white"
          :class="isRouteActive(item.path) ? 'bg-white/10 text-white' : ''"
          @click="navigateTo(item.name)"
        >
          <span>{{ item.label }}</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "PublicTopBar",

  data() {
    return {
      isMobileMenuOpen: false,
      navItems: [
        { name: "why-scio", label: "Why Scio", path: "/why-scio/" },
        { name: "contact", label: "Contact", path: "/contact/" },
      ],
    };
  },

  computed: {
    mobileItems() {
      return [
        ...this.navItems,
        { name: "login", label: "Log in", path: "/login/" },
      ];
    },
  },

  methods: {
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    navigateTo(routeName) {
      const target = { name: routeName };
      const resolved = this.$router.resolve(target);

      if (!resolved?.matched?.length) {
        console.warn("[PublicTopBar] Route not registered", target);
        return;
      }

      this.isMobileMenuOpen = false;

      if (resolved.fullPath === this.$route.fullPath) return;

      this.$router.push(target);
    },

    isRouteActive(path) {
      return this.$route.path === path || this.$route.path.startsWith(path);
    },
  },
};
</script>

<style>
.public-topbar [class~="rounded-md"],
.public-topbar [class~="rounded-lg"] {
  border-radius: 0 !important;
}
</style>
